/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Data
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import { Card } from "@mui/material";
import RegistrationData from "layouts/tables/data/registrationTableData";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function Registration() {
  const { sales, tasks } = reportsLineChartData;

  const location = useLocation();
  const { fair } = location.state || {};

  const [list, setList] = useState([]);

  // const RegistrationLists = () => {
  //   return (
  //     <MDBox p={0}>
  //       <RegistrationData fair={fair}></RegistrationData>
  //     </MDBox>
  //   );
  // };

  return (
    <DashboardLayout>
      <DashboardNavbar title="Registration" subTitle={fair?.name} />
      <MDBox py={3}>
        {/* <RegistrationLists /> */}
        <RegistrationData fair={fair}></RegistrationData>
      </MDBox>
      <MDBox mb={2} />
      <Footer />
    </DashboardLayout>
  );
}

export default Registration;
